import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchUserGroupMockData } from "../Utils/UserProfileFetchGroupsData.js"
import POProfileImageUploader from "../Utils/ProfileImageUploader";
import "../Styles/common-styles.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PageProfileModal from "../../../common/PopupPages/PageProfile";
import {
  faVideoCamera,
  faMobile,
  faMessage,
} from "@fortawesome/free-solid-svg-icons";

const GroupProfile = ({userId, profileId}) => {
      const [groups, setGroups] = useState(null);
      const [ProfileImage, setProfileImage] = useState(null);
      const [showPopup, setShowPopup] = useState(false); 
      const [renderOperation, setRenderOperation] = useState(null);
      
      useEffect(() => {
        const loadProfileData = async () => {
          const profileData = await fetchUserGroupMockData(profileId);
          if (profileData) {
            setProfileImage(profileData.imageUrl);
            setGroups(profileData?.connections?.groups || []);
          }
        };
    
        // setShowPopup(true);
  
        if (profileId) {
          loadProfileData();
        }
      }, [profileId]);

      useEffect(() => {
        if (ProfileImage) {
          console.log("Updated profile image state:", ProfileImage);
        }
      }, [ProfileImage]);
    
      const handleUserClick = (operationType, userId, mode) => {
        setShowPopup(false);
        setRenderOperation({
          operationType,
          data: { userId },
          mode,
        });
      };

      const handleCloseModal = () => {
        setRenderOperation(null);
      };

      return (
        <div className="up-profile-container">
          <div
            className="overlay-grid-layout"
            style={{
              width: "100%",
              height: "1200px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div className="up-blog-grid-upper" style={{ width: "100%", height: "20%", display: "flex", flexDirection: "row" }}>
              <POProfileImageUploader
                userId={userId}
                profileImage={ProfileImage}
                profileName={profileId}
                operationType="group"
              />
            </div>

            <div className="up-blog-grid-lower" style={{ width: "100%", height: "80%", marginTop: 30 }}>
              {!Array.isArray(groups) || groups.length === 0 ? (
                <p className="text-black">No Group found</p>
                ) : (
                groups.map((group) => {
                  const shouldShowModal =
                    ["home", "messaging", "audio", "video"].includes(renderOperation?.operationType) &&
                    renderOperation?.data?.userId === group.userId;
      
                  return (
                    <React.Fragment key={group.userId}>
                      <div
                        className="up-profile-card"
                        style={{ display: "flex", flexDirection: "column", marginBottom: 10 }}
                      >
                        <div className="ua-profile">
                          <img src={group.imageUrl} alt="Friend" className="uf-image" />
                          <div className="uf-details">
                            <p className="text-header" style={{ textAlign: "center", fontWeight: "bold" }}>
                              {group.userName}
                            </p>
                            {/* <p className="text-label" style={{ textAlign: "center" }}>
                              {friend.location}, {friend.activelevel}
                            </p> */}
                          </div>
                          <div className="uf-profile-action">
                            <button
                              className="uf-action-btn"
                              onClick={() => handleUserClick("messaging", group.userId, "friend")}
                            >
                              <FontAwesomeIcon icon={faMessage} style={{ color: "rgb(116, 108, 116)" }} />
                            </button>
                            <button
                              className="uf-action-btn"
                              onClick={() => handleUserClick("audio", group.userId, "friend")}
                            >
                              <FontAwesomeIcon icon={faMobile} style={{ color: "rgb(116, 108, 116)" }} />
                            </button>
                            <button
                              className="uf-action-btn"
                              onClick={() => handleUserClick("video", group.userId, "friend")}
                            >
                              <FontAwesomeIcon icon={faVideoCamera} style={{ color: "rgb(116, 108, 116)" }} />
                            </button>
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })
              )}
            </div>
          </div>
      
          {["messaging", "audio", "video"].includes(renderOperation?.operationType) && (
            <div
              className="up-modal-overlay"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
              }}
            >
              <div
                style={{
                  background: "#1a1a1a",
                  padding: "20px",
                  borderRadius: "12px",
                  minWidth: "300px",
                  maxWidth: "90%",
                  maxHeight: "90%",
                  overflowY: "auto",
                }}
              >
                <PageProfileModal
                  userId={renderOperation.data.userId}
                  operationType={renderOperation.operationType}
                  mode={renderOperation.mode}
                  onClose={handleCloseModal}
                />
              </div>
            </div>
          )}
        </div>
      );      
};

export default GroupProfile;